import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'column-chart',
    templateUrl: './column-chart.component.html',
    styleUrls: ['./column-chart.component.scss']
})
export class ColumnChartComponent implements OnInit {

    @Input() data;
    @Input() options;

    constructor() {
        this.data = [
            ['S', 3],
            ['M', 0],
            ['T', 8],
            ['W', 17],
            ['T', 1],
            ['F', 12],
            ['S', 6]
        ];

        this.options = {
            chart: {
                padding: 5
            },
            column: {
                width: 10,
                gap: 1,
                color: '#cccccc'
            }
        };
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/column-chart/column-chart.component.ts